import { ContentfulClientApi, createClient } from 'contentful'

/**
 * Singleton Contentful CDA client. Uses environment variables to avoid
 * leaking tokens.
 *
 * Required env vars (add them to your .env file or build system):
 * - REACT_APP_CONTENTFUL_REACTIVATIONS_SPACE_ID
 * - REACT_APP_CONTENTFUL_REACTIVATIONS_ACCESS_TOKEN
 */

let _client: ContentfulClientApi<any> | null = null

export function getContentfulClient(): ContentfulClientApi<any> {
  if (_client) {
    return _client
  }

  const space = process.env.REACT_APP_CONTENTFUL_REACTIVATIONS_SPACE_ID
  const accessToken =
    process.env.REACT_APP_CONTENTFUL_REACTIVATIONS_ACCESS_TOKEN

  if (!space || !accessToken) {
    // Fail fast – missing configuration means we cannot fetch dynamic pages.
    // This should surface clearly in logs/Sentry so we can fix deployments.
    throw new Error(
      'Contentful client not configured. Please set REACT_APP_CONTENTFUL_REACTIVATIONS_SPACE_ID and REACT_APP_CONTENTFUL_REACTIVATIONS_ACCESS_TOKEN.'
    )
  }

  _client = createClient({ space, accessToken })
  return _client!
}
